module.exports = __webpack_public_path__ + "img/icono_cervezas.6c89aee9.svg";